import React, { FC } from 'react';
import { StyledHeader, Title } from './Atoms';
import { BlankLink } from 'src/modules/shared/components';
import { IconButton, Tooltip } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  linkPath: string;
  title: string;
  hasUnreadFeedbackInBook: boolean;
  handleFeedbackClick: () => void;
};

const BookWithUnfinishedTrajectoriesHeader: FC<Props> = ({
  linkPath,
  title,
  hasUnreadFeedbackInBook,
  handleFeedbackClick,
}) => {
  return (
    <StyledHeader>
      <BlankLink to={linkPath}>
        <Title>{title}</Title>
      </BlankLink>
      <div className="controls">
        {hasUnreadFeedbackInBook && (
          <Tooltip title={'Nieuwe feedback'}>
            <IconButton className="feedback" color="primary" onClick={handleFeedbackClick}>
              <FontAwesomeSpriteIcon icon={SpriteIconsLight.FEEDBACK_TEXT} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </StyledHeader>
  );
};

export default BookWithUnfinishedTrajectoriesHeader;
